import AccountConfig from './profile/config';

export const ModuleMapUserInfo = {
  account: AccountConfig,
}
